<template>
     <v-form ref="form" class="w-100 h-100 white">
        <v-row class="no-frame w-100 h-100">
            <v-col >
                 <div class="w-100">
                     <f-title :title="$t('inb.detail.head.title')" />
                    <v-row dense class="mb-5">
                        <v-col class="pa-0">
                            <c-inb-context
                                :item     = "item"
                                :readonly = "readonly"
                                @morph    = "onMorph"
                                @changed  = "onContext"
                                ref       = "siteselect"
                            />
                        </v-col>
                    </v-row>
                     <f-title :title="$t ('inb.detail.assessment.title.main')" class="mt-2 ml-1" />
                     <v-row dense>
                         <v-col class="pr-2 col-6">
                             <f-read-only-field
                                 :value    = "item.atype ? item.atype : '---'"
                                 :label    = "$t('inb.detail.assessment.typetext')"
                                 class     = "mt-1"
                             />
                         </v-col>
                         <v-col class="pl-2 col-6">
                             <f-enum-select
                                 v-model   = "item.assessmentType"
                                 :label    = "$t('inb.detail.assessment.type')"
                                 module    = "inb"
                                 type      = "assessmentTypes"
                                 :rules    = "[requiredRule]"
                                 @input   = "onChanged"
                             />
                         </v-col>
                     </v-row>

                     <v-row dense>
                         <v-col class="pr-2 col-6">
                             <f-read-only-field
                                 :value    = "item.result ? item.result : '---'"
                                 :label    = "$t('inb.detail.assessment.resulttext')"
                             />
                         </v-col>
                         <v-col class="pl-2 col-6">
                             <f-enum-select
                                 v-model   = "item.assessmentResult"
                                 :label    = "$t('inb.detail.assessment.result')"
                                 module    = "inb"
                                 type      = "assessmentResults"
                                 :rules    = "[requiredRule]"
                                 class     = "mt-0"
                                 @input   = "onChanged"
                             />
                         </v-col>
                     </v-row>

                     <v-row dense>
                        <v-col class="pr-2">
                            <f-date-picker
                                v-model="item.dateAssessment"
                                label ="inb.detail.assessment.date"
                                :readonly = "readonly"
                                class="w-100"
                            />
                        </v-col>
                        <v-col class="pl-2">
                            <f-date-picker
                                v-model="item.dateNextAssessment"
                                label   ="inb.detail.assessment.dateNext"
                                :readonly = "readonly"
                                class="w-100"
                            />
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <v-col class="pr-2">
                            <f-date-picker
                                v-model   = "item.dateRemedyOfDefects"
                                label     = "inb.detail.assessment.dateRemedy"
                                :readonly = "readonly"
                                class     = "w-100"
                            />
                        </v-col>
                        <v-col class="pl-2">
                        </v-col>
                    </v-row>

                    <f-title
                        :title="$t('inb.detail.assessment.title.contact')"
                        class="mt-2 ml-1"
                    />

                    <v-row dense>
                        <v-col class="pr-2">
                            <v-text-field
                                v-if="item.contact"
                                v-model="item.contact.name"
                                :label="$t('inb.detail.assessment.contact.name')"
                                :readonly      = "readonly"
                                :disabled      = "readonly"
                                class          = "mt-0"
                                autocomplete   = "off"
                                autocorrect    = "off"
                                autocapitalize = "off"
                                spellcheck     = "false"
                            />
                        </v-col>
                        <v-col class="pl-2">
                            <v-text-field
                                v-if="item.contact"
                                v-model="item.contact.phone"
                                :label="$t('inb.detail.assessment.contact.phone')"
                                :readonly      = "readonly"
                                :disabled      = "readonly"
                                class          = "mt-0"
                                autocomplete   = "off"
                                autocorrect    = "off"
                                autocapitalize = "off"
                                spellcheck     = "false"
                            />
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <v-col class="pr-2">
                            <v-text-field
                                v-if="item.contact"
                                v-model="item.contact.email"
                                :label="$t('inb.detail.assessment.contact.mail')"
                                :readonly      = "readonly"
                                :disabled      = "readonly"
                                autocomplete   = "off"
                                autocorrect    = "off"
                                autocapitalize = "off"
                                spellcheck     = "false"
                            />
                        </v-col>
                        <v-col class="pl-2">
                            <v-text-field
                                v-if="item.contact"
                                v-model="item.contact.mobile"
                                :label="$t('inb.detail.assessment.contact.mobile')"
                                :readonly      = "readonly"
                                :disabled      = "readonly"
                                autocomplete   = "off"
                                autocorrect    = "off"
                                autocapitalize = "off"
                                spellcheck     = "false"
                            />
                        </v-col>
                    </v-row>
                </div>
            </v-col>
             <v-col >
                <f-title :title="$t('inb.detail.assessment.title.defects')" class="mt-0" />
                <inc-assessment-faults
                    :faults   = "item.faults"
                    :height   = "620"
                    :readonly = "readonly"
                    @change   = "onFaults"
                />
            </v-col>
        </v-row>
    </v-form>
</template>

<script>

import FTitle              from "@/modules/core/components/utils/FTitle";
import IncAssessmentFaults from "@/modules/inc/steps/components/assessment/IncAssessmentFaults";
import FDatePicker         from "@/modules/core/components/utils/FDatePicker";
import CInbContext         from "@/modules/inb/components/controlls/CInbContext";
import FEnumSelect from "@/modules/core/components/utils/FEnumSelect";
import FReadOnlyField from "@/modules/core/components/utils/FReadOnlyField";
import Core from "@/modules/core/service/Core";
import Inb from "@/modules/inb/service/Inb";

export default {
    name: "CInboxAssessment",

    props: {
        item: {
            default: function () {
                return {
                    id: null,
                    assessment: {
                        incidentId           : null,
                        result               : null,
                        comment              : null,
                        atype                : null,
                        assessmentType       : null,
                        assessmentResult     : null,
                        dateAssessment       : null,
                        dateNextAssessment   : null,
                        dateRemedyOfDefects  : null,
                        contactName          : null,
                        contactPhone         : null,
                        contactMail          : null,
                        contactMobile        : null,
                        faults               : []
                    }
                }
            }
        },
        readonly: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        }
    },

    components: {
        FReadOnlyField,
        FEnumSelect,
        CInbContext,
        IncAssessmentFaults,
        FTitle,
        FDatePicker,
    },

    data: () => ({
    }),

    computed: {
        requiredRule() {
            return Core.rule.required;
        },

        hasFaults () {
            if (this.item.faults)
                return this.item.faults.length > 0;
            return false;
        },
    },

    methods: {
        onSave (success) {
            this.$refs.form.validate();
            Inb.store(this, this.item).then((data) => {
                if (this.$refs.siteselect) {
                    this.$refs.siteselect.closeMenu ();
                }

                if (success) success(data)
            });
        },

        onFaults (faults) {
            this.item.faults = faults;
        },

        onChanged () {
            this.$emit("changed", this.item)
        },

        onContext (item) {
            this.$emit("context", item)
        },

        onMorph (event) {
            this.$emit("morph", event)
        },
    }
}
</script>

<style scoped>
</style>